import React, { useState } from 'react'
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';

const ShowImageComponent = ({image, showImage, setShowImage}) => {
    return(
        <Modal  size='xl' fullscreen={true} show={showImage} onHide={() => { setShowImage(!showImage)}}  scrollable>
            <Modal.Header closeButton></Modal.Header>
                <img src={image} style={{height:'90%',width:'100%'}}/>
        </Modal>
    )
}

function ChequeOrDDModal({showChequeOrDDModal, setShowChequeOrDDModal, chequeOrDDModalDetails}) {
    const [details, setDetails] = useState({})
    const [showDetails,setShowDetails] = useState(false)
    const [showImage,setShowImage] = useState(false)
    const [image,setImage] = useState('')
    const onchangeTerm = (event) => {
        const term = (event.target.value+" Fee")
        const studentDetails = chequeOrDDModalDetails.student
        setShowDetails(true)
        for (let eachTerm of studentDetails['termFee']){
            if((term === Object.keys(eachTerm)[0])){
                if(eachTerm[Object.keys(eachTerm)[0]]?.offlineDetails?.paymentType === "DD"){
                    const ddDetails = {"Bank Name":eachTerm[Object.keys(eachTerm)[0]]?.offlineDetails?.DDdetails?.bankName,
                                       "Bank Branch":eachTerm[Object.keys(eachTerm)[0]]?.offlineDetails?.DDdetails?.bankBranch,
                                       "DD Number  ":eachTerm[Object.keys(eachTerm)[0]]?.offlineDetails?.DDdetails?.ddNumber,
                                       "DD Image   ":eachTerm[Object.keys(eachTerm)[0]]?.offlineDetails?.DDdetails?.ddImage }
                    setDetails(ddDetails)
                }else if(eachTerm[Object.keys(eachTerm)[0]]?.offlineDetails?.paymentType === "Cheque"){
                    const chequeDetails = {"Bank Name    ":eachTerm[Object.keys(eachTerm)[0]]?.offlineDetails?.ChequeDetails?.bankName,
                                           "Bank Branch  ":eachTerm[Object.keys(eachTerm)[0]]?.offlineDetails?.ChequeDetails?.bankBranch,
                                           "Cheque Number":eachTerm[Object.keys(eachTerm)[0]]?.offlineDetails?.ChequeDetails?.chequeNumber,
                                           "Cheque Image ":eachTerm[Object.keys(eachTerm)[0]]?.offlineDetails?.ChequeDetails?.chequeImage }
                    setDetails(chequeDetails)
                }
            }
        }
    }

  return (
    <>
    {showImage && <ShowImageComponent image={image} showImage={showImage} setShowImage={setShowImage}/>}
    <Modal size="md" show={showChequeOrDDModal} onHide={() => { setShowChequeOrDDModal(!showChequeOrDDModal); setShowDetails(false) }}  scrollable>
            <Modal.Header closeButton>
                <Modal.Title> <p style={{padding:0, margin:0, color:"#333333", fontFamily:["Helvetica", "sans-serif"], fontSize:"20px"}}>Select Term</p></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <select style={{ backgroundImage: 'none' }} placeholder="Select the Term" onChange={onchangeTerm} className="form-control mb-3" aria-label="Default select example">
                        <option disabled selected hidden value="" >Select The Term</option>
                        {chequeOrDDModalDetails?.termsList?.map((each,i) => {
                            return <option key={i} value={each}>{each}</option>
                        })}
                    </select>
                   {showDetails && 
                    (Object.keys(details).map(each => {
                        if(each.includes("Image")){
                            return (<div>
                                        <p><span className='font-weight-bold'>{each}</span> : <img src={details[each]} style={{height:'150px',width:"100%"}}/></p>
                                        <div>
                                            <a className='btn btn-warning mr-2' onClick={() => {setImage(details[each]);setShowImage(true)}} >View</a>
                                            <a className='btn btn-secondary' href={`${details[each]}`} download >Download</a>
                                        </div>
                                    </div>
                            )
                        }
                        return (
                            <p><span className='font-weight-bold'>{each}</span> : {details[each]}</p>
                        )
                    }))
                   }
                   {/* {showDetails && } */}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => { setShowChequeOrDDModal(false); setShowDetails(false) }}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    </>
  )
}

export default ChequeOrDDModal